import { css } from '@emotion/css';
import cameraDisabledImg from '@volumental/assets/icons/camera-disable.svg';
import { Button } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';

const container = css`
  user-select: none;
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(50, 50, 50, 0.3);
`;

const errorImage = css`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const errorText = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

interface CameraErrorProps {
  title: string;
  onClick: () => void;
  callToAction: string;
}

export function CameraError({
  title,
  onClick,
  callToAction,
}: CameraErrorProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={container} style={{ backgroundColor: 'black' }}>
      <div className={errorImage}>
        <img src={cameraDisabledImg} alt={t('imageAlt.disabledCamera')} />
        <div className={errorText}>
          <span style={{ color: 'white', padding: '10px' }}>{title}</span>
          <Button
            backgroundColor="white"
            forgroundColor="black"
            onClick={onClick}
          >
            {callToAction}
          </Button>
        </div>
      </div>
    </div>
  );
}
